import { render, staticRenderFns } from "./facility.vue?vue&type=template&id=5f0fcdae&scoped=true"
import script from "./facility.vue?vue&type=script&lang=js"
export * from "./facility.vue?vue&type=script&lang=js"
import style0 from "./facility.vue?vue&type=style&index=0&id=5f0fcdae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fcdae",
  null
  
)

export default component.exports